module.exports = __webpack_public_path__ + "img/[爆竹].c1ae8c53.svg";